// src/context/ApplicationTypeContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "./AuthContext";

// Create Context
const ApplicationTypeContext = createContext();

// Provider Component
export const ApplicationTypeProvider = ({ children }) => {
  const [ApplicationTypes, setApplicationTypes] = useState([]);
  const { isAuthenticated, authVersion } = useAuth();

  const fetchApplicationTypes = async () => {
    try {
      const response = await api.get("/ApplicationTypes");
      setApplicationTypes(response.data);
    } catch (error) {}
  };

  // Fetch when user is authenticated (and re-fetch after login)
  useEffect(() => {
    if (isAuthenticated) {
      fetchApplicationTypes();
    }
  }, [isAuthenticated, authVersion]);

  return (
    <ApplicationTypeContext.Provider value={{ ApplicationTypes }}>
      {children}
    </ApplicationTypeContext.Provider>
  );
};

// Custom hook
export const useApplicationTypes = () => {
  const { ApplicationTypes } = useContext(ApplicationTypeContext);
  return ApplicationTypes;
};
